import React from "react";

interface CalendarFilledIconProps {
  className?: string;
}

const CalendarFilledIcon: React.FC<CalendarFilledIconProps> = ({
  className = "",
}) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_18571_6083)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7274 1.74552C18.7395 2.07485 18.7489 2.47063 18.7499 2.91957C19.1871 2.94443 19.5791 2.97031 19.9275 2.99592C21.5657 3.11638 22.8541 4.3636 22.9951 6.0121C23.1228 7.5044 23.25 9.79545 23.25 13C23.25 16.2046 23.1228 18.4956 22.9951 19.9879C22.8541 21.6364 21.5657 22.8836 19.9275 23.0041C18.2938 23.1242 15.6998 23.25 12 23.25C8.3002 23.25 5.70615 23.1242 4.07246 23.0041C2.43423 22.8836 1.14589 21.6364 1.00487 19.9879C0.877215 18.4956 0.75 16.2046 0.75 13C0.75 9.79545 0.87722 7.5044 1.00487 6.0121C1.14589 4.3636 2.43423 3.11638 4.07246 2.99592C4.42086 2.9703 4.81294 2.94443 5.2501 2.91957C5.2511 2.47063 5.2605 2.07484 5.27265 1.74552C5.30075 0.983765 5.7908 0.315562 6.6111 0.267361C6.79525 0.256541 7.007 0.25 7.25 0.25C7.493 0.25 7.70475 0.256541 7.8889 0.267361C8.7092 0.315562 9.19925 0.983765 9.22735 1.74552C9.2382 2.03898 9.24685 2.38521 9.2493 2.77479C10.0879 2.75912 11.0039 2.75 12 2.75C12.9961 2.75 13.9121 2.75912 14.7507 2.77479C14.7532 2.38521 14.7618 2.03898 14.7726 1.74552C14.8007 0.983765 15.2908 0.315562 16.1111 0.267361C16.2952 0.256541 16.507 0.25 16.75 0.25C16.993 0.25 17.2048 0.256541 17.3889 0.267361C18.2092 0.315562 18.6993 0.983765 18.7274 1.74552ZM5.25 12C5.25 11.3097 5.80965 10.75 6.5 10.75H17.5C18.1903 10.75 18.75 11.3097 18.75 12C18.75 12.6904 18.1903 13.25 17.5 13.25H6.5C5.80965 13.25 5.25 12.6904 5.25 12ZM5.25 17C5.25 16.3097 5.80965 15.75 6.5 15.75H12C12.6903 15.75 13.25 16.3097 13.25 17C13.25 17.6904 12.6903 18.25 12 18.25H6.5C5.80965 18.25 5.25 17.6904 5.25 17Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_18571_6083">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CalendarFilledIcon;
